import { Component, DOCUMENT, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ENV } from '@bodyanalytics/app-config';

@Component({
  standalone: true,
  selector: 'bodyanalytics-calendar-button',
  templateUrl: './calendar-button.component.html',
  styleUrls: ['./calendar-button.component.scss'],
})
export class CalendarButtonComponent {
  private router = inject(Router);
  private document = inject<Document>(DOCUMENT);
  private appConfig = inject(ENV);

  calendar() {
    this.document.location.href = `${this.appConfig.calendarUrl}`;
  }
}
